import localhost from "../../../apis/localhost";
import { SITE_PROVENANCE } from "../../../constants/sharepointAccess";
import { selectAllowedSitesDiscovery } from "../allowedSitesSelectors";
import {
  setDiscoveryError,
  setDiscoveryLoading,
  setDiscoverySites,
} from "../allowedSitesSlice";
import { PAGE_SIZE, REQUEST_CONFIG } from "./allowedSitesConstants";
import {
  allowedSitesUrl,
  asSiteRows,
  handleDiscoveryError,
} from "./allowedSitesUtils";

export const fetchAvailableSites =
  ({ isCloudMode, append = false }) =>
  async (dispatch, getState) => {
    const discovery = selectAllowedSitesDiscovery(getState());
    const nextSkipToken = append ? discovery.nextSkipToken : undefined;
    dispatch(setDiscoveryLoading(true));
    dispatch(setDiscoveryError(null));
    try {
      const { data } = await localhost.get(
        allowedSitesUrl(isCloudMode, "/available-sites"),
        { ...REQUEST_CONFIG, params: { limit: PAGE_SIZE, nextSkipToken } }
      );
      dispatch(
        setDiscoverySites({
          sites: asSiteRows(data?.sites, SITE_PROVENANCE.browse),
          nextSkipToken: data?.pagination?.nextSkipToken || null,
          append,
        })
      );
    } catch (error) {
      handleDiscoveryError(dispatch, error);
    } finally {
      dispatch(setDiscoveryLoading(false));
    }
  };
